/*
 * MER conversion tracking
 * Fires events to GA4 (gtag) and Meta Pixel (fbq) for design funnel actions.
 * Loaded sitewide via theme.liquid.
 *
 * 2026-05-30 PATCH (freeze fix):
 * REMOVED the chat-tracking block entirely. The chat tracker had:
 *  - A body-wide MutationObserver scanning for chat iframes on every DOM mutation
 *  - A document click listener with case-insensitive attribute substring selectors
 *  - A postMessage listener
 * All three fired constantly thanks to Camweara/Klaviyo/Reputon DOM churn,
 * contributing to the mobile PDP freeze.
 *
 * Chat is a rare conversion path on jewellery PDPs anyway — the lost signal
 * is minor compared to the freeze cost.
 *
 * KEPT: phone-call tracking (lives in theme.liquid), consult clicks, builder
 * funnel events, AI design form events, quote form submits.
 */
(function () {
  'use strict';

  function fireGA(name, params) {
    if (typeof gtag === 'function') {
      gtag('event', name, params || {});
    }
  }

  function fireMeta(name, params) {
    if (typeof fbq === 'function') {
      fbq('track', name, params || {});
    }
  }

  function fireBoth(gaName, metaName, params) {
    fireGA(gaName, params);
    fireMeta(metaName, params);
  }

  // Funnel page views — fires on landing
  function onReady() {
    var path = window.location.pathname;

    // 1. Ring builder page visited (builder now lives on the collection URL;
    //    Meta event switched from InitiateCheckout to ViewContent so real
    //    checkout signals stay clean now that the pixel actually fires)
    if (path.indexOf('/pages/custom-design-engagement-ring') === 0 ||
        path.indexOf('/collections/custom-engagement-ring-builder') === 0 ||
        path.indexOf('/collections/design-your-engagement-ring') === 0) {
      fireBoth('builder_started', 'ViewContent', {
        content_category: 'ring-builder',
        content_name: 'pencilshop-builder'
      });
    }

    // 2. AI design form page visited
    if (path.indexOf('/pages/custom-design-form') === 0) {
      fireBoth('ai_design_viewed', 'ViewContent', {
        content_category: 'ai-design-tool',
        content_name: 'wishtype-ai-form'
      });
    }

    // 3. Appointment / consult landing page visited
    if (path.indexOf('/pages/showroom-appointment') === 0 ||
        path.indexOf('/pages/appointmentpage') === 0) {
      fireBoth('appointment_page_viewed', 'ViewContent', {
        content_category: 'appointment',
        content_name: 'showroom-appointment'
      });
    }

    // Contact form success — Shopify reloads the page with contact_posted=true
    // after a successful submission, so this only counts real sends.
    if (window.location.search.indexOf('contact_posted=true') > -1) {
      var contactKey = 'gj_contact_lead_' + path;
      var alreadyCounted = false;
      try { alreadyCounted = !!sessionStorage.getItem(contactKey); } catch (err) {}
      if (!alreadyCounted) {
        try { sessionStorage.setItem(contactKey, '1'); } catch (err) {}
        fireBoth('contact_form_submitted', 'Lead', {
          content_category: 'contact-form',
          page_path: path
        });
      }
    }

    bindFormSubmits();
    bindConsultClicks();
    /* REMOVED 2026-05-30: bindChatOpens() — see header comment.
       If chat conversions become a priority later, re-enable with a
       scoped observer (a specific Shopify Inbox iframe selector, not
       document.body subtree). */
  }

  // 4. Quote form submission tracking
  function bindFormSubmits() {
    var quoteForm = document.querySelector('#custom-quote, form[action*="quote"], .mer-quote-form form');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function () {
        fireBoth('quote_submitted', 'Lead', {
          content_category: 'quote-form',
          value: 0,
          currency: 'AUD'
        });
      });
    }

    // AI form via Wishtype: listen for postMessage from the iframe
    // (single listener, cheap — only does string indexOf checks on incoming messages)
    window.addEventListener('message', function (event) {
      if (!event || !event.data) return;
      var data = event.data;

      // Calendly inline/popup embeds emit this on a completed booking.
      // Firing it here, on our own domain, preserves source attribution
      // that is lost when the booking completes on calendly.com.
      if (data && data.event === 'calendly.event_scheduled') {
        if (!/^https:\/\/([a-z0-9-]+\.)?calendly\.com$/.test(event.origin || '')) return;
        var payload = data.payload || {};
        var inviteeUri = (payload.invitee && payload.invitee.uri) || (payload.event && payload.event.uri) || '';
        var bookingKey = 'gj_booking_' + (inviteeUri || 'session');
        window.__gjBookings = window.__gjBookings || {};
        if (window.__gjBookings[bookingKey]) return;
        window.__gjBookings[bookingKey] = true;
        try {
          if (sessionStorage.getItem(bookingKey)) return;
          sessionStorage.setItem(bookingKey, '1');
        } catch (err) {}
        var bookingId = inviteeUri ? inviteeUri.split('/').pop() : '';
        fireGA('showroom_booking_success2', {
          content_category: 'appointment',
          source: 'calendly_embed',
          booking_id: bookingId,
          page_path: window.location.pathname + window.location.search
        });
        if (typeof fbq === 'function') {
          fbq('track', 'Schedule', { content_category: 'appointment' }, bookingId ? { eventID: 'booking_' + bookingId } : {});
        }
        return;
      }

      var type = (typeof data === 'string') ? data : (data.type || data.event || '');

      if (typeof type === 'string') {
        if (type.indexOf('wishtype_submit') > -1 || type.indexOf('design_submitted') > -1) {
          fireBoth('ai_design_submitted', 'Lead', {
            content_category: 'ai-design-tool',
            value: 0,
            currency: 'AUD'
          });
        }

        // PencilShop builder completion. Scoped: pencil lifecycle messages
        // (loaded, resize, etc.) must not fire leads, and one lead per session.
        var isCompletion = type.indexOf('design_complete') > -1 ||
          (type.indexOf('pencil') > -1 && (type.indexOf('complete') > -1 || type.indexOf('submit') > -1 || type.indexOf('added_to_cart') > -1));
        if (isCompletion) {
          var already = false;
          try { already = !!sessionStorage.getItem('gj_builder_lead'); } catch (err) {}
          if (!already) {
            try { sessionStorage.setItem('gj_builder_lead', '1'); } catch (err) {}
            fireBoth('builder_completed', 'Lead', {
              content_category: 'ring-builder',
              value: 0,
              currency: 'AUD'
            });
          }
        }
      }
    });
  }

  // 5. Consultation CTA clicks
  // Single delegated click listener, simple substring checks on href. Cheap.
  function bindConsultClicks() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('a');
      if (!el) return;
      var href = el.getAttribute('href') || '';
      if (href.indexOf('showroom-appointment-direct-link') > -1 ||
          href.indexOf('calendly.com') > -1 ||
          href.indexOf('book') > -1 && href.indexOf('appointment') > -1) {
        fireGA('consult_clicked', {
          content_category: 'consult',
          link_url: href,
          page_path: window.location.pathname
        });
      }
    });
  }

  // 6. Globo (Powerful Contact Form Builder) submissions.
  // Globo fires gtag('event','globo_form_submit',...) which the page-scope
  // Google tag already forwards to GA4, so only Meta and Klaviyo are fired
  // here. Session-deduped.
  function onGloboSubmit() {
    var already = false;
    try { already = !!sessionStorage.getItem('gj_globo_lead'); } catch (err) {}
    if (already) return;
    try { sessionStorage.setItem('gj_globo_lead', '1'); } catch (err) {}
    fireMeta('Lead', {
      content_category: 'contact-form',
      content_name: 'globo-contact-form'
    });
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['track', 'Contact Form Submitted', { form: 'globo' }]);
    }
  }

  function isGloboEntry(entry) {
    if (!entry) return false;
    if (entry.event === 'globo_form_submit') return true;
    if (entry.length && entry[0] === 'event' && entry[1] === 'globo_form_submit') return true;
    return false;
  }

  (function hookDataLayer() {
    window.dataLayer = window.dataLayer || [];
    for (var i = 0; i < window.dataLayer.length; i++) {
      if (isGloboEntry(window.dataLayer[i])) { onGloboSubmit(); break; }
    }
    var wrapped = null;
    function wrap() {
      var originalPush = window.dataLayer.push;
      if (originalPush === wrapped) return;
      wrapped = function () {
        for (var j = 0; j < arguments.length; j++) {
          try { if (isGloboEntry(arguments[j])) onGloboSubmit(); } catch (err) {}
        }
        return originalPush.apply(window.dataLayer, arguments);
      };
      window.dataLayer.push = wrapped;
    }
    wrap();
    var rewraps = 0;
    var timer = setInterval(function () {
      rewraps++;
      wrap();
      if (rewraps >= 10) clearInterval(timer);
    }, 3000);
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
